module.exports = __webpack_public_path__ + "media/svg/je-ad293465.svg";